import { param, route } from "router";

export const ROUTES = {
  HOME: route("/"),
  ASSET: route("/asset").path(param("assetId")),
  TRANSACTION: route("/transaction").path(param("transactionId")),
};
